import { NgModule } from '@angular/core';
import { ssToasterConfig } from '@blocks/toastr/ss-toastr.config';
import { ToastrModule, ToastrService } from 'ngx-toastr';

@NgModule({
  imports: [ToastrModule.forRoot(ssToasterConfig)],
  declarations: [],
})
export class SsToastrModule {}
